export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <g clipPath="url(#clip0_567_3953)">
                <path
                    d="M12.8344 4.15085C12.557 4.14093 12.2879 4.24679 12.0916 4.4431L4.20699 12.3277C3.81646 12.7182 3.81646 13.3514 4.20699 13.7419L11.2781 20.813C11.6686 21.2035 12.3017 21.2035 12.6923 20.813L20.5768 12.9284C20.7732 12.7321 20.879 12.463 20.8691 12.1855L20.5918 4.42819L12.8344 4.15085Z"
                    stroke="url(#paint0_linear_567_3953)"
                    strokeLinejoin="round"
                />
                <path d="M15.8345 9.18555H15.8245" stroke="url(#paint1_linear_567_3953)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_567_3953" x1="23.5" y1="5.18555" x2="8.5" y2="18.6855" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="1" stopColor="#CA9554" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_3953" x1="17.3345" y1="10.6856" x2="14.3345" y2="8.18555" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#C79250" />
                    <stop offset="1" stopColor="#F6D18F" />
                </linearGradient>
                <clipPath id="clip0_567_3953">
                    <rect width="24" height="24" fill="white" transform="translate(0.5 0.185547)" />
                </clipPath>
            </defs>
        </svg>
    );
}
